import bezier from 'bezier-easing'

export default bezier(0.32, -0.16, 0, 1.51)
// export default bezier(0.49, -0.16, 0, 1.09)
